import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Eyebrow } from "@/components/site/primitives";
import { ArrowRight } from "lucide-react";

export const OpenQuestions = () => {
  const { t } = useLang();
  return (
    <section className="relative py-28 sm:py-36 bg-espresso/30 border-y border-gold/10" data-testid="open-questions-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <Eyebrow>{t.questions.eyebrow}</Eyebrow>
          <h2 className="mt-5 font-display font-light text-sand text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
            {t.questions.title}
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 grid md:grid-cols-[1fr_auto_1.2fr] gap-6 items-center rounded-2xl border border-gold/20 bg-ivy/40 p-6 sm:p-8">
            <div className="rounded-xl border border-burgundy/40 bg-burgundy/10 p-5">
              <p className="text-xs uppercase tracking-widest text-sand/50 mb-2">✗</p>
              <p className="text-sand/80 text-base sm:text-lg font-light leading-relaxed">{t.questions.swapClosed}</p>
            </div>
            <ArrowRight className="mx-auto text-gold rotate-90 md:rotate-0" size={26} />
            <div className="rounded-xl border border-moss/50 bg-moss/15 p-5">
              <p className="text-xs uppercase tracking-widest text-gold mb-2">✓</p>
              <p className="text-sand text-base sm:text-lg font-light leading-relaxed">{t.questions.swapOpen}</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="mt-12 mb-6 font-serifluxe uppercase text-xs tracking-mystic text-gold">{t.questions.listTitle}</p>
        </Reveal>
        <div className="grid sm:grid-cols-2 gap-x-10 gap-y-3">
          {t.questions.list.map((q, i) => (
            <Reveal key={i} delay={(i % 2) * 0.05}>
              <div className="flex items-start gap-4 py-3 border-b border-gold/10">
                <span className="text-gold text-sm mt-1">✶</span>
                <p className="text-sand/80 text-base sm:text-lg font-light leading-relaxed">{q}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OpenQuestions;
